import { Model } from '@vuex-orm/core';
import uuid from '@/lib/helpers/uuid';

export class AppProgressQueueItem extends Model {
    static entity = 'appProgressQueueItems';

    static fields() {
        return {
            id: this.string(() => uuid()),
            name: this.string(''),
            loading: this.boolean(false),
            success: this.string(null).nullable(),
            error: this.string(null).nullable()
        };
    }

    get message() {
        if (this.success) {
            return this.success;
        }

        if (this.error) {
            return this.error;
        }

        return null;
    }
}

export default AppProgressQueueItem;
